import Vue from 'vue'
import axios from 'axios'
import  { Message } from 'element-ui'
import { getToken, getLanguage} from '@/utils/auth'
import {getParams,getDomainPrefix} from "@/utils/common.js"
import store from '@/store'
let sendCount = 0
// 不需要loadding的接口
const whiteList = ['parseAndExcuteCommand','getLastOne','getFamenByPosition']

let domain = window.location.pathname
//  domain = "http://dev.everiaction.com/#/login"
let domainPrefix = getDomainPrefix(domain)

Vue.prototype.$source = {};

function packAxios(baseUrl,baseAPI){
  baseUrl = baseUrl||""
  let tempAxios = axios.create({
    baseURL: (baseAPI||process.env.VUE_APP_BASE_API)+"/"+baseUrl,
    timeout:60000
  })
  tempAxios.interceptors.request.use(config => {
    config.headers['Authorization'] = getToken()
    config.headers['Content-Type'] = 'application/json;charset=utf-8';
    config.headers['realm'] = domainPrefix=='ft'?'':domainPrefix; //如果使用的二级域名为繁体，则realm 为空
    config.headers['Accept-Language'] = getLanguage();

    // 在这里处理一下请求参数
    if(config.params) {
      // 处理params参数
      /*config.params = */filterParams(config.params)
    }
    if(config.data) {
      // 处理data参数
      /* config.data = */ filterParams(config.data)
    }
    
    let lastLink = config.url.split("/").slice(-1)[0];
    lastLink = lastLink && lastLink.split("?")[0] || "";
    store.state.loadding = true
    //如果url中含有hideLoadding 关闭loadding  或者 白名单中的接口也不需要loadding
    if(config.url.indexOf("hideLoadding")!=-1||whiteList.indexOf(lastLink) != -1){
      store.state.loadding = false
    }
    sendCount++
    config.url = encodeURI(config.url)
    config.url = config.url.replace(new RegExp(/(#)/g),encodeURIComponent('#'))
    config.url = config.url.replace(new RegExp(/\+/g),encodeURIComponent('+'))
    let projectId = store.state.app.projectInfo.id
    let params = getParams(config.url)
    if(projectId&&!params.noProjectId&&!params.projectId&&!config.params?.projectId){
    	if(config.url.indexOf("?")!=-1){
				config.url+="&projectId="+projectId
			}else{
				config.url+="?projectId="+projectId
			}
    }
    //取消掉上次的请求，添加cancelRequest参数
    let attr = config.url.split('?')[0]
    if(params.t){
      attr = attr + '?t='+params.t
    }
    if(Vue.prototype.$source[attr]&&params.cancelRequest){
    	Vue.prototype.$source[attr]();
    	Vue.prototype.$source[attr] = null;
    	store.state.loadding = true;
    }
    // 设置cancelToken对象，会存在相同的请求没有取消掉
    config.cancelToken = new axios.CancelToken((c) => {
        Vue.prototype.$source[attr] = c
    })
    //如果切换的项目是非悬索桥的接口，取消IOT-SERVER-BRIDGE请求  解决watch projectInfo中调用接口的问题
    if(baseUrl == 'IOT-SERVER-BRIDGE'&&store.state.app.projectInfo.type!=-10){
    	Vue.prototype.$source[attr]();
    	Vue.prototype.$source[attr] = null; 
    }
    return config
  }, error => {
    sendCount--
    if (sendCount <= 0) {
      store.state.loadding = false
    }
    let errormsg = error.length < 10 ? error :'系统异常，请刷新重试'
    Promise.reject(errormsg)
  })
  tempAxios.interceptors.response.use(response => {
    if(response.config.url.indexOf("hideLoadding")!=-1){//如果url中含有hideLoadding 关闭loadding
      store.state.loadding = false
    }
    sendCount--
    if (sendCount <= 0) {
      store.state.loadding = false
    }
    if (response.data.status === 200 ){
      return response.data  //返回response
    }else if (response.data.status === 40101) {
      store.dispatch('LogOut')
    }else if(response.data.status === 500||response.data.status === 250){
      let message = response.data.message
      Message({
        message: message,
        type: 'warning',
        duration: 5 * 1000
      })
      return Promise.reject(response.data)
    }else{
      return response.data||{}
    }
  }, error => {
    sendCount--
    if (sendCount <= 0) {
      store.state.loadding = false
    }
    if(error.response&&error.response.status == 404){
      //  接口404 不做任何处理
      // location.href = location.origin+"/#/404"
    }else{
      return Promise.reject(error)
    }
  })
  return tempAxios
}

function filterParams(params) {
  if(isFormData(params)){
    return params
  }else {
    let str = JSON.stringify(params)
    const reg = /('|")\s*(.*?)\s*(\1)/igms
    str = str.replace(reg, "$1$2$3")
    return JSON.parse(str)
  }
}


function isFormData(obj) {
  return typeof obj === 'object' && obj instanceof FormData;
}

export default {
  $http: packAxios(""),
  $httpBase: packAxios(''),
  $httpProj: packAxios('IOT-SERVER-PROJ'),
  $httpEs: packAxios('IOT-SERVER-ES'),
  $httpDisk: packAxios('IOT-SERVER-DISK'),
  $httpSys: packAxios('IOT-SERVER-SYSTEM3'),
  $httpSysMock: packAxios('IOT-SERVER-SYSTEM3'),
  $httpBd: packAxios('IOT-SERVER-BD'),
  $httpData: packAxios('IOT-DATA-GATHER'),
  $httpWater: packAxios('IOTECH-WATER-CONTROL'),
  $httpBridge: packAxios('IOT-SERVER-BRIDGE'),
  $httpPlatform: packAxios('IOT-JACKUP-PLATFORM','https://www.everiaction.com'),
  $httpAnalytical : packAxios('IOT-SERVER-ANALYTICAL'),
  $httpReport : packAxios('IOT-SERVER-REPORT'),
  $httpTsy: packAxios('IOT-TSY-ALERT'),
  $httpGather: packAxios('IOT-SERVER-GATHER'),
  $httpAlert:packAxios('IOT-SERVER-ALERT'),
  $httpCustom:packAxios('IOT-ADAPTER-CUSTOM'),
  $httpCheck:packAxios('IOT-SERVER-CHECK'),
  $httpCorrect:packAxios('IOT-SERVER-CORRECT')

}